<template>
  <sw-modal :open="$attrs.open" @close="$emit('close')">
    <sw-panel class="modal-template center-y">
      <span
        slot="header"
        class="flex center base-modal-title"
      >{{ dictionnary ? dictionnary.templateMenu.titremodal : ""}}</span>
      <div
        class="modal-template-content"
      >{{ dictionnary ? dictionnary.templateMenu.contenumodal : ""}}</div>
      <sw-button
        class="button-template-modal center mt-10"
        :label="dictionnary ? dictionnary.templateMenu.boutonmodal : ''"
        @click="go"
      />
    </sw-panel>
  </sw-modal>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { EventBus, TEMPLATE_FIRST } from '@/model/EventBus'

export default {
  name: 'TemplateModal',
  components: {},
  beforeCreate() {},
  async created() {
    this.dictionnary = await this.getLanguages
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      dictionnary: null
    }
  },
  props: {},
  computed: {
    ...mapGetters(['getLanguages'])
  },
  methods: {
    go() {
      this.$emit('close')
      EventBus.$emit(TEMPLATE_FIRST)
    }
  },
  watch: {}
}
</script>






// WEBPACK FOOTER //
// src/components/modal/TemplateModal.vue